import classNames from 'classnames'
import { MdAdd } from 'react-icons/md'

import type { MouseEvent, ReactElement, ReactNode } from 'react'

import Button from '~/components/Buttons/Button'

import './styles.scss'

interface Props {
  children?: ReactNode
  className?: string
  disabled?: boolean
  isValid?: boolean
  label: string
  onAddClick: VoidFunction
  onInputClick: VoidFunction
}

const ActionInput = ({
  children,
  className,
  disabled,
  isValid,
  label,
  onAddClick,
  onInputClick,
}: Props): ReactElement => {
  const componentClasses = classNames('action-input-component', { 'is-valid': isValid }, className)

  const handleClick = (evt: MouseEvent<HTMLDivElement>) => {
    evt.stopPropagation()
    onInputClick()
  }

  return (
    <div className={componentClasses} onClick={!disabled ? handleClick : undefined}>
      {children ? (
        <div className={classNames('action-input-component__value', { disabled })}>{children}</div>
      ) : !disabled ? (
        <Button onClick={onAddClick} type="button">
          <MdAdd color="#fff" size={15} /> Add {label}
        </Button>
      ) : (
        'No value'
      )}
    </div>
  )
}

export default ActionInput
